import { render, staticRenderFns } from "./FullContactField.vue?vue&type=template&id=cca2f7c2&"
import script from "./FullContactField.vue?vue&type=script&lang=js&"
export * from "./FullContactField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cca2f7c2')) {
      api.createRecord('cca2f7c2', component.options)
    } else {
      api.reload('cca2f7c2', component.options)
    }
    module.hot.accept("./FullContactField.vue?vue&type=template&id=cca2f7c2&", function () {
      api.rerender('cca2f7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/FullContactField.vue"
export default component.exports